import type { IQueueStorage, QueuedEventRecord } from './types';

export class LocalStorageQueueStorage implements IQueueStorage {
  private readonly storageKey: string;

  constructor(storageKey: string) {
    this.storageKey = storageKey;
  }

  init(): void {
    // no-op
  }

  destroy(): void {
    // persistence survives destroy by design
  }

  load(): readonly QueuedEventRecord[] {
    if (typeof window === 'undefined' || !window.localStorage) return [];

    try {
      const raw = window.localStorage.getItem(this.storageKey);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as QueuedEventRecord[];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  save(records: readonly QueuedEventRecord[]): void {
    if (typeof window === 'undefined' || !window.localStorage) return;

    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(records));
    } catch {
      // quota exceeded — caller may apply backpressure
    }
  }

  getAdapterName(): string {
    return 'LocalStorageQueueStorage';
  }

  isAvailable(): boolean {
    if (typeof window === 'undefined') return false;

    try {
      const testKey = `${this.storageKey}__probe`;
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }
}
